export const PURCHASABLE = "PURCHASABLE";
export const INSTORE_ONLY = "INSTORE_ONLY";
export const MAX_ONLY = "MAX_ONLY";
export const TRADE_ACCOUNT_ONLY = "TRADE_ACCOUNT_ONLY";
export const CREATIVE_GLASS_ONLY = "CREATIVE_GLASS_ONLY";
export const ENQUIRE_ONLY = "ENQUIRE_ONLY";
export const NOT_AVAILABLE = "NOT_AVAILABLE";